// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"594":"about","702":"querybridge","945":"dashboard"}[chunkId] || chunkId) + "." + {"317":"c3f71a04","594":"bc967d7b","702":"d944c3e6","945":"cba9d68e"}[chunkId] + ".js";
};